import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  MenuItem,
  Box,
  Typography,
  Grid,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { getAllAgentsService } from "../../../../services/agentService";
import { toast } from "react-toastify";
import { createPigmyService } from "../../../../services/pigmyService";
import axios from "axios";
import { API_URL } from "../../../../utils/apiUtils";

// Validation Schema
const validationSchema = Yup.object().shape({
  agent: Yup.string().required("Agent is required"),
  pigmyPlan: Yup.string().required("Pigmy Plan is required"),
  frequency: Yup.string().required("Frequency is required"),
  collectionAmount: Yup.number()
    .required("Collection Amount is required")
    .positive("Amount must be positive"),
  startDate: Yup.date().required("Start Date is required"),
  endDate: Yup.date().required("End Date is required"),
  nomineeName: Yup.string().required("Nominee Name is required"),
  nomineeRelation: Yup.string().required("Nominee Relation is required"),
  nomineePhoneNumber: Yup.string().required("Nominee Phone Number is required"),
  nomineeAadhaarNumber: Yup.string().required(
    "Nominee Aadhaar Number is required"
  ),
  nomineePanNumber: Yup.string().required("Nominee Pan Number is required"),
  nomineeAccountNumber: Yup.string().required(
    "Nominee Account Number is required"
  ),
  nomineeAccountName: Yup.string().required("Nominee Account Name is required"),
  nomineeIFSC: Yup.string().required("Nominee IFSC is required"),
  nomineeBranch: Yup.string().required("Nominee Branch is required"),
});

const CreatePigmyModal = ({ open, onClose, id }) => {
  const [agents, setAgents] = useState([]);
  const [nomineeDetails, setNomineeDetails] = useState();
  const fetchAgents = async () => {
    try {
      const agents = await getAllAgentsService(0, 50);
      setAgents(agents?.agentsWithPhoneContacts); // Adjust this based on API response structure
    } catch (err) {
      toast.error(err.message);
    }
  };

  const getNomineeDetails = async () => {
    try {
      console.log("hiiiii");
      const token = sessionStorage.getItem("accessToken");
      const response = await axios.get(
        `${API_URL}/customer/get-nominee-details`,
        {
          params: {
            id,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setNomineeDetails(response?.data?.nomineeDetails);
    } catch (error) {}
  };

  const calculateDates = (plan) => {
    const startDate = new Date();
    let endDate = new Date();
    if (plan === "12") {
      endDate.setFullYear(startDate.getFullYear() + 1);
    } else if (plan === "6") {
      endDate.setMonth(startDate.getMonth() + 6);
    } else if (plan === "24") {
      endDate.setFullYear(startDate.getFullYear() + 2);
    } else if (plan === "36") {
      endDate.setFullYear(startDate.getFullYear() + 3);
    }
    return {
      startDate: startDate.toISOString().split("T")[0],
      endDate: endDate.toISOString().split("T")[0],
    };
  };
  const handleStartDate = (values, date) => {
    let startDate = new Date(date);
    let endDate = new Date(startDate); // Copy startDate
    let plan = values.pigmyPlan;

    if (plan === "12") {
      endDate.setFullYear(startDate.getFullYear() + 1);
    } else if (plan === "6") {
      endDate.setMonth(startDate.getMonth() + 6);
    } else if (plan === "24") {
      endDate.setFullYear(startDate.getFullYear() + 2);
    } else if (plan === "36") {
      endDate.setFullYear(startDate.getFullYear() + 3);
    }

    return {
      startDate: startDate.toISOString().split("T")[0],
      endDate: endDate.toISOString().split("T")[0],
    };
  };

  const handleSubmit = async (values) => {
    try {
      const payload = { ...values, user: id };
      await createPigmyService(payload);
      toast.success("Pigmy created successfully!");
      onClose();
    } catch (error) {
      toast.error("Failed to create Pigmy");
    }
  };

  useEffect(() => {
    fetchAgents();
    getNomineeDetails();
  }, []);

  return (
    <Dialog
      open={open}
      maxWidth="lg"
      fullWidth
      sx={{ width: "800px", margin: "auto" }}
    >
      <DialogTitle>Create Pigmy</DialogTitle>
      <Formik
        enableReinitialize
        initialValues={{
          agent: "",
          pigmyPlan: "",
          frequency: "",
          collectionAmount: "",
          startDate: "",
          endDate: "",
          nomineeName: nomineeDetails?.nomineeName || "",
          nomineeRelation: nomineeDetails?.nomineeRelation || "",
          nomineePhoneNumber: nomineeDetails?.nomineePhoneNumber || "",
          nomineeAadhaarNumber: nomineeDetails?.nomineeAadhaarNumber || "",
          nomineePanNumber: nomineeDetails?.nomineePanNumber || "",
          nomineeAccountNumber: nomineeDetails?.nomineeAccountNumber || "",
          nomineeAccountName: nomineeDetails?.nomineeAccountName || "",
          nomineeIFSC: nomineeDetails?.nomineeIFSC || "",
          nomineeBranch: nomineeDetails?.nomineeBranch || "",
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, handleChange, setFieldValue, errors, touched }) => (
          <Form>
            <DialogContent>
              <Box
                sx={{ display: "grid", gap: 2, gridTemplateColumns: "1fr 1fr" }}
              >
                <Box>
                  <Typography>Agent *</Typography>
                  <Field
                    as={TextField}
                    size="small"
                    name="agent"
                    select
                    fullWidth
                    error={touched.agent && Boolean(errors.agent)}
                    helperText={touched.agent && errors.agent}
                    required
                  >
                    {agents.map((agent) => (
                      <MenuItem key={agent._id} value={agent._id}>
                        {agent.userName}
                      </MenuItem>
                    ))}
                  </Field>
                </Box>
                <Box>
                  <Typography>Pigmy Plan *</Typography>
                  <Field
                    as={TextField}
                    name="pigmyPlan"
                    size="small"
                    select
                    fullWidth
                    error={touched.pigmyPlan && Boolean(errors.pigmyPlan)}
                    helperText={touched.pigmyPlan && errors.pigmyPlan}
                    required
                    onChange={(e) => {
                      handleChange(e);
                      const { startDate, endDate } = calculateDates(
                        e.target.value
                      );
                      setFieldValue("startDate", startDate);
                      setFieldValue("endDate", endDate);
                    }}
                  >
                    <MenuItem value="6">6 months</MenuItem>
                    <MenuItem value="12">12 months</MenuItem>
                    <MenuItem value="24">24 months</MenuItem>
                    <MenuItem value="36">36 months</MenuItem>
                  </Field>
                </Box>
                <Box>
                  <Typography>Frequency *</Typography>
                  <Field
                    as={TextField}
                    name="frequency"
                    size="small"
                    select
                    fullWidth
                    error={touched.frequency && Boolean(errors.frequency)}
                    helperText={touched.frequency && errors.frequency}
                    required
                  >
                    <MenuItem value="Daily">Daily</MenuItem>
                    <MenuItem value="Weekly">Weekly</MenuItem>
                    <MenuItem value="Monthly">Monthly</MenuItem>
                  </Field>
                </Box>
                <Box>
                  <Typography>Collection Amount *</Typography>
                  <Field
                    as={TextField}
                    size="small"
                    name="collectionAmount"
                    type="number"
                    fullWidth
                    error={
                      touched.collectionAmount &&
                      Boolean(errors.collectionAmount)
                    }
                    helperText={
                      touched.collectionAmount && errors.collectionAmount
                    }
                    required
                  />
                </Box>
                <Box>
                  <Typography>Start Date *</Typography>
                  <Field
                    as={TextField}
                    name="startDate"
                    type="date"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    onChange={(e) => {
                      handleChange(e);
                      const { startDate, endDate } = handleStartDate(
                        values,
                        e.target.value
                      );
                      setFieldValue("startDate", startDate);
                      setFieldValue("endDate", endDate);
                    }}
                    error={touched.startDate && Boolean(errors.startDate)}
                    helperText={touched.startDate && errors.startDate}
                    required
                  />
                </Box>
                <Box>
                  <Typography>End Date *</Typography>
                  <Field
                    as={TextField}
                    name="endDate"
                    type="date"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    error={touched.endDate && Boolean(errors.endDate)}
                    helperText={touched.endDate && errors.endDate}
                    required
                    InputProps={{
                      readOnly: true, // Makes the field read-only
                    }}
                  />
                </Box>
              </Box>

              <Typography variant="h6" mt={2}>
                Nominee Details
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <Typography mt={1}>Nominee Name</Typography>
                  <Field
                    fullWidth
                    size="small"
                    name="nomineeName"
                    as={TextField}
                    error={touched.nomineeName && Boolean(errors.nomineeName)}
                    helperText={touched.nomineeName && errors.nomineeName}
                    onKeyDown={(e) => {
                      // Allow only alphabets and spaces
                      if (
                        !/[a-zA-Z\s]/.test(e.key) && // Allow alphabets and spaces
                        e.key !== "Backspace" && // Allow Backspace
                        e.key !== "Delete" && // Allow Delete
                        e.key !== "ArrowLeft" && // Allow Left Arrow
                        e.key !== "ArrowRight" // Allow Right Arrow
                      ) {
                        e.preventDefault();
                      }
                    }}
                    sx={{
                      "& .MuiInputBase-root": {
                        borderRadius: "8px",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Typography mt={1}>Nominee Relation</Typography>
                  <Field
                    fullWidth
                    size="small"
                    name="nomineeRelation"
                    error={
                      touched.nomineeRelation && Boolean(errors.nomineeRelation)
                    }
                    helperText={
                      touched.nomineeRelation && errors.nomineeRelation
                    }
                    as={TextField}
                    sx={{
                      "& .MuiInputBase-root": {
                        borderRadius: "8px",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Typography mt={1}>Nominee Phone Number</Typography>
                  <Field
                    fullWidth
                    size="small"
                    name="nomineePhoneNumber"
                    error={
                      touched.nomineePhoneNumber &&
                      Boolean(errors.nomineePhoneNumber)
                    }
                    helperText={
                      touched.nomineePhoneNumber && errors.nomineePhoneNumber
                    }
                    as={TextField}
                    onKeyDown={(e) => {
                      // Allow only numbers
                      if (
                        !/[0-9]/.test(e.key) && // Allow digits
                        e.key !== "Backspace" && // Allow Backspace
                        e.key !== "Delete" && // Allow Delete
                        e.key !== "ArrowLeft" && // Allow Left Arrow
                        e.key !== "ArrowRight" // Allow Right Arrow
                      ) {
                        e.preventDefault();
                      }
                    }}
                    inputProps={{
                      maxLength: 10, // Restrict length to 10
                    }}
                    sx={{
                      "& .MuiInputBase-root": {
                        borderRadius: "8px",
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={4}>
                  <Typography mt={1}>Nominee Aadhaar Number</Typography>
                  <Field
                    fullWidth
                    size="small"
                    name="nomineeAadhaarNumber"
                    error={
                      touched.nomineeAadhaarNumber &&
                      Boolean(errors.nomineeAadhaarNumber)
                    }
                    helperText={
                      touched.nomineeAadhaarNumber &&
                      errors.nomineeAadhaarNumber
                    }
                    as={TextField}
                    onKeyDown={(e) => {
                      // Allow only numbers
                      if (
                        !/[0-9]/.test(e.key) && // Allow digits
                        e.key !== "Backspace" && // Allow Backspace
                        e.key !== "Delete" && // Allow Delete
                        e.key !== "ArrowLeft" && // Allow Left Arrow
                        e.key !== "ArrowRight" // Allow Right Arrow
                      ) {
                        e.preventDefault();
                      }
                    }}
                    inputProps={{
                      maxLength: 12, // Restrict length to 10
                    }}
                    sx={{
                      "& .MuiInputBase-root": {
                        borderRadius: "8px",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Typography mt={1}>Nominee Pan Number</Typography>
                  <Field
                    fullWidth
                    size="small"
                    name="nomineePanNumber"
                    error={
                      touched.nomineePanNumber &&
                      Boolean(errors.nomineePanNumber)
                    }
                    helperText={
                      touched.nomineePanNumber && errors.nomineePanNumber
                    }
                    as={TextField}
                    sx={{
                      "& .MuiInputBase-root": {
                        borderRadius: "8px",
                      },
                    }}
                    inputProps={{
                      maxLength: 120, // Restrict length to 10
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Typography mt={1}>Nominee Account Number</Typography>
                  <Field
                    fullWidth
                    size="small"
                    name="nomineeAccountNumber"
                    error={
                      touched.nomineeAccountNumber &&
                      Boolean(errors.nomineeAccountNumber)
                    }
                    helperText={
                      touched.nomineeAccountNumber &&
                      errors.nomineeAccountNumber
                    }
                    as={TextField}
                    onKeyDown={(e) => {
                      // Allow only numbers
                      if (
                        !/[0-9]/.test(e.key) && // Allow digits
                        e.key !== "Backspace" && // Allow Backspace
                        e.key !== "Delete" && // Allow Delete
                        e.key !== "ArrowLeft" && // Allow Left Arrow
                        e.key !== "ArrowRight" // Allow Right Arrow
                      ) {
                        e.preventDefault();
                      }
                    }}
                    inputProps={{
                      maxLength: 15, // Restrict length to 10
                    }}
                    sx={{
                      "& .MuiInputBase-root": {
                        borderRadius: "8px",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Typography mt={1}>Nominee Account Name</Typography>
                  <Field
                    fullWidth
                    size="small"
                    name="nomineeAccountName"
                    error={
                      touched.nomineeAccountName &&
                      Boolean(errors.nomineeAccountName)
                    }
                    helperText={
                      touched.nomineeAccountName && errors.nomineeAccountName
                    }
                    as={TextField}
                    sx={{
                      "& .MuiInputBase-root": {
                        borderRadius: "8px",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Typography mt={1}>Nominee IFSC</Typography>
                  <Field
                    fullWidth
                    size="small"
                    name="nomineeIFSC"
                    error={touched.nomineeIFSC && Boolean(errors.nomineeIFSC)}
                    helperText={touched.nomineeIFSC && errors.nomineeIFSC}
                    as={TextField}
                    sx={{
                      "& .MuiInputBase-root": {
                        borderRadius: "8px",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Typography mt={1}>Nominee Branch</Typography>
                  <Field
                    fullWidth
                    size="small"
                    name="nomineeBranch"
                    error={
                      touched.nomineeBranch && Boolean(errors.nomineeBranch)
                    }
                    helperText={touched.nomineeBranch && errors.nomineeBranch}
                    as={TextField}
                    sx={{
                      "& .MuiInputBase-root": {
                        borderRadius: "8px",
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
              <Button onClick={onClose} color="inherit">
                Close
              </Button>
              <Button type="submit" variant="contained" color="primary">
                Submit
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default CreatePigmyModal;
